<template>
  <div>
    <v-dialog
      v-model="dialog"
      :max-width="options.width"
      :style="{ zIndex: options.zIndex }"
      @keydown.esc="cancel"
    >
      <v-card>
        <v-container class="px-10 pt-8">
          <v-form v-model="isFormValid">
            <p class="subtitle-1 font-weight-bold mb-2">
              Refund Security Deposit
            </p>
            <v-row>
              <v-col class="py-0" cols="12" sm="12" md="3">
                <p class="caption">Tenant:</p>
              </v-col>
              <v-col class="py-0" cols="12" sm="12" md="9">
                <p class="caption font-weight-bold">{{ tenantName }}</p>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0" cols="12" sm="12" md="3">
                <p class="caption">Unit:</p>
              </v-col>
              <v-col class="py-0" cols="12" sm="12" md="9">
                <p class="caption font-weight-bold">{{ unitName }}</p>
              </v-col>
            </v-row>

            <v-divider class="my-4"></v-divider>

            <v-row>
              <v-col class="py-0" cols="12" sm="12" md="12">
                <v-currency-field
                  v-model="amount"
                  type="number"
                  label="Amount"
                  prepend-inner-icon="mdi-cash"
                  dense
                  outlined
                  :rules="amountRules"
                >
                </v-currency-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0" cols="12" sm="12" md="12">
                <v-textarea
                  v-model="description"
                  name="description"
                  label="Description"
                  prepend-inner-icon="mdi-information"
                  dense
                  outlined
                >
                </v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0" cols="12" sm="12" md="12">
                <v-menu
                  v-model="dateRefundedMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="formattedDateRefunded"
                      label="Date Refunded"
                      v-bind="attrs"
                      readonly
                      dense
                      outlined
                      v-on="on"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon small class="mt-1">mdi-calendar-month</v-icon>
                      </template>
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dateRefunded"
                    no-title
                    scrollable
                    @input="dateRefundedMenu = false"
                  >
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-form>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="font-weight-bold"
              color="primary darken-1"
              text
              :disabled="!isFormValid"
              @click="finish"
              >Finish</v-btn
            >
            <v-btn
              class="font-weight-bold"
              color="grey darken-1"
              text
              @click="cancel"
              >Cancel</v-btn
            >
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DATEPICKER, YYYYMMDD, dayjs } from '../../util/date'
import { getUsableAmount } from '../../util/securityDeposit'

export default {
  data() {
    return {
      dialog: false,
      options: {
        color: 'primary',
        width: 500,
        zIndex: 200
      },
      tenantName: '',
      amount: 0,
      maxAmount: 0,
      description: '',
      dateRefunded: dayjs().format(DATEPICKER),
      dateRefundedMenu: false,
      unitName: '',
      isFormValid: false,
      amountRules: [
        (v) => {
          let amount = v
          if (typeof amount === 'string') {
            amount = Number(v.replace(/[^0-9.-]+/g, ''))
          }
          return (
            amount * 100 <= this.maxAmount ||
            'Cannot exceed the refundable amount'
          )
        },
        (v) => !!v || 'Please enter an amount'
      ]
    }
  },
  computed: {
    formattedDateRefunded() {
      return this.dateRefunded ? dayjs(this.dateRefunded).format(YYYYMMDD) : ''
    }
  },
  methods: {
    open(securityDeposit) {
      this.dialog = true
      this.tenantName = securityDeposit.tenantName
      this.maxAmount = getUsableAmount(securityDeposit)
      this.amount = this.maxAmount
      this.description = securityDeposit.description
      this.unitName = securityDeposit.unitName
      this.securityDepositId = securityDeposit.securityDepositId
    },
    async finish() {
      try {
        this.$root.$setLoading(true)
        await this.$store.dispatch('securityDeposits/refund', {
          securityDepositId: this.securityDepositId,
          description: this.description,
          dateRefunded:
            this.dateRefunded && dayjs(this.dateRefunded).format(YYYYMMDD),
          amount: this.amount
        })

        this.dialog = false
        this.$root.$setLoading(false)
        await this.$root.$confirm({
          title: 'Refund Security Deposit',
          message: `The security deposit has been refunded.`,
          reconfirmOnly: true,
          confirmText: 'OK',
          options: {
            color: 'success'
          }
        })
        this.$emit('reload')
      } catch (err) {
        await this.$root.$confirm({
          title: 'Refund Security Deposit',
          message: err.message,
          reconfirmOnly: true,
          confirmText: 'OK',
          options: {
            color: 'error'
          }
        })
      }
    },
    cancel() {
      this.dialog = false
    }
  }
}
</script>
